module.exports = __webpack_public_path__ + "static/media/ChooseWalletProvider.d8afc65f.PNG";